import * as API from '../api'

export const FETCHING_FISPQS = 'FETCHING_FISPQS'
export const FETCH_FISPQS = 'FETCH_FISPQS'
export const FETCH_FISPQS_ERROR = 'FETCH_FISPQS_ERROR'

export const fetchProductsFispq = (
  page,
  rowsPerPage,
  orderBy,
  order, 
  issue_initial_date = '',
  issue_final_date = '',
  expiration_initial_date = '',
  expiration_final_date = ''
) => {
  return dispatch => {
    dispatch({
      type: FETCHING_FISPQS,
      value: true
    })

    return API.fispq
      .getProductsFispq(
        page,
        rowsPerPage,
        orderBy,
        order,
        issue_initial_date,
        issue_final_date,
        expiration_initial_date,
        expiration_final_date)
      .then(response => {
        const { data = {} } = response
        const { can_change_status: canChangeStatus, items, last_update, total_records, pagination } = data

        dispatch({
          type: FETCH_FISPQS,
          canChangeStatus,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_FISPQS_ERROR
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/fispq.js